// Only the words on an engraved quaich can be changed without rebuilding its Infinite Options bundle.
// window.walEngravingEditor is shared by the cart page (below) and the slide-out cart (assets/cart-drawer.js loads this file on the first click on "Edit engraving").
(() => {
  if (window.walEngravingEditor) return;
  const element = (tag, attributes = {}, children = []) => {
    const node = document.createElement(tag);
    Object.entries(attributes).forEach(([key, value]) => {
      if (key === 'text') node.textContent = value;
      else node.setAttribute(key, value);
    });
    node.append(...children);
    return node;
  };
  const reveal = (editor) => {
    const scroller = editor.closest('.cart-drawer__body');
    if (!scroller) return;
    const viewport = window.visualViewport;
    const bounds = scroller.getBoundingClientRect();
    const bottom = Math.min(bounds.bottom, viewport ? viewport.offsetTop + viewport.height : window.innerHeight) - 8;
    const rect = editor.getBoundingClientRect();
    if (rect.bottom > bottom) scroller.scrollTop += rect.bottom - bottom;
    if (rect.top < bounds.top) scroller.scrollTop -= bounds.top - rect.top;
  };

  const open = ({ anchor, item, onSaved, onCancel }) => {
    const existing = anchor.nextElementSibling;
    if (existing?.classList.contains('wal-cart-edit')) return existing;
    const pairSkus = ['577/2', 'G008-09-992', 'G1501-08-170', 'G1212-09-301', 'G1211-09-301', 'WOC-WG-BAR2', 'WOC-WG-CASK2'];
    const pair = pairSkus.includes((item.sku || '').toUpperCase()) && /^(Both glasses:|Glass 1:)\n/.test(item.properties.Text.replace(/\r\n/g, '\n'));
    const validPair = (value) => {
      const lines = value.split('\n');
      const split = lines.indexOf('Glass 2:');
      const groups = lines[0] === 'Both glasses:' ? [lines.slice(1)] : lines[0] === 'Glass 1:' && split > 0 ? [lines.slice(1, split), lines.slice(split + 1)] : [];
      return groups.length > 0 && groups.every((group) => group.length <= 4 && group.some((line) => line.trim()) && group.every((line) => line.length <= 80 && !['Glass 1:', 'Glass 2:', 'Both glasses:'].includes(line.trim())));
    };
    // Glass awards (they have an Infill choice, or an Award "1 of 7" note) take up to 8 lines and the app's 500 characters
    const award = !pair && (item.properties.Infill !== undefined || item.properties.Award !== undefined);
    const limit = award ? { lines: 8, chars: 500 } : { lines: 6, chars: 485 };
    const input = element('textarea', { rows: pair || award ? '8' : '3', maxlength: pair ? '670' : String(limit.chars), 'aria-label': pair ? 'Both glasses engraving instructions' : 'Engraving words' });
    input.value = item.properties.Text.replace(/\r\n/g, '\n');
    const error = element('p', { class: 'wal-cart-edit__error', role: 'alert' });
    const save = element('button', { type: 'button', class: 'button button--primary', text: 'Save' });
    const cancel = element('button', { type: 'button', class: 'link', text: 'Cancel' });
    const editor = element('div', { class: 'wal-cart-edit' }, [
      element('label', { text: 'Engraving words' }),
      input,
      element('p', { class: 'wal-cart-edit__note', text: pair ? 'Keep the Both glasses: heading, or Glass 1: and Glass 2: headings. Up to four short lines per glass. Lettering and logo changes require re-adding the pair.' : 'Need a different lettering or a logo change? Remove this item and add it again, or tell us at checkout.' }),
      error,
      element('div', { class: 'wal-cart-edit__actions' }, [save, cancel]),
    ]);
    anchor.after(editor);
    input.focus();
    reveal(editor);
    if (window.visualViewport) window.visualViewport.addEventListener('resize', () => reveal(editor), { once: true });
    input.addEventListener('change', (event) => event.stopPropagation());
    const close = () => {
      editor.remove();
      if (onCancel) onCancel();
    };
    cancel.addEventListener('click', close);
    editor.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      event.preventDefault();
      event.stopPropagation();
      close();
    });
    save.addEventListener('click', async () => {
      const lines = input.value.replace(/\r\n/g, '\n').replace(/\s+$/, '').split('\n');
      if (pair ? !validPair(lines.join('\n')) : lines.length > limit.lines || lines.some((line) => line.length > 80) || !input.value.trim()) {
        error.textContent = pair ? 'Keep the glass instruction headings and add wording for both glasses: up to 4 lines and 80 characters per line each.' : `Please enter engraving words (up to ${limit.lines} lines, 80 characters per line).`;
        input.focus();
        return;
      }
      error.textContent = '';
      save.disabled = true;
      const properties = { ...item.properties, Text: lines.join('\n') };
      if (typeof properties._io_properties === 'string') {
        try {
          const options = JSON.parse(properties._io_properties);
          if (options && typeof options === 'object' && Object.hasOwn(options, 'Text')) {
            options.Text = properties.Text;
            properties._io_properties = JSON.stringify(options);
          }
        } catch (_) {
          /* Keep an unrecognised app value unchanged. */
        }
      }
      try {
        const response = await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: item.key, quantity: item.quantity, properties }),
        });
        const result = await response.json();
        if (!response.ok || result.errors || result.status) throw new Error(result.description || 'Could not save. Please try again.');
        if (onSaved) await onSaved(result);
        else location.reload();
      } catch (failure) {
        error.textContent = failure.message || 'Could not save. Please try again.';
        save.disabled = false;
      }
    });
    return editor;
  };

  window.walEngravingEditor = { open };

  const cartItems = document.querySelector('cart-items');
  if (!cartItems) return;
  let loading = false;
  let rerun = false;

  const render = async () => {
    if (loading) {
      rerun = true;
      return;
    }
    loading = true;
    try {
      const response = await fetch('/cart.js');
      if (!response.ok) throw new Error('Could not load cart');
      const cart = await response.json();
      cart.items.forEach((item, index) => {
        if (!item.properties?._io_order_group || !item.properties.Text) return;
        const row = cartItems.querySelector(`#CartItem-${index + 1}`);
        if (!row || row.querySelector('.wal-cart-edit__button')) return;
        const property = [...row.querySelectorAll('.cart-item__details .product-option')].find((option) => option.querySelector('dt')?.textContent.trim() === 'Text:');
        if (!property) return;
        const button = element('button', { type: 'button', class: 'link wal-cart-edit__button', text: 'Edit' });
        property.querySelector('dd').after(button);
        button.addEventListener('click', () => {
          if (row.querySelector('.wal-cart-edit')) return;
          open({
            anchor: property,
            item,
            onSaved: async () => {
              if (typeof cartItems.onCartUpdate === 'function') await cartItems.onCartUpdate();
              else location.reload();
            },
            onCancel: () => {
              button.hidden = false;
              button.focus();
            },
          });
          button.hidden = true;
        });
      });
    } catch (error) {
      console.error('Engraving cart editor:', error);
    } finally {
      loading = false;
      if (rerun) {
        rerun = false;
        render();
      }
    }
  };

  new MutationObserver((changes) => {
    if (changes.some((change) => [...change.addedNodes].some((node) => node.nodeType === 1 && (node.matches('.cart-item, .js-contents') || node.querySelector('.cart-item')))))
      render();
  }).observe(cartItems, { childList: true, subtree: true });
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event.source !== 'cart-items') render();
    });
  }
  render();
})();
